(function () {
    'use strict';

    angular.module("imApp").factory("productPicService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductPicture: function (parms) {
                return $ihttp.post({
                    method: 1066,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1067,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1068,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
